import {TweenLite, Quint, TimelineMax, TweenMax} from "gsap";

class HeroBackground {

    constructor(windowSizes) {
        this.windowSizes = windowSizes

        this.duration = 1.5

        this.container = document.querySelector('.section-hero__background')
        this.backgroundDesktop = this.container.dataset.background
        this.backgroundMobile = this.container.dataset.backgroundMobile
        this.line = document.querySelector('.section-hero__text__title__line__in')
        this.desc = document.querySelector('.section-hero__text__desc')
    }

    init() {
        this.setBackground()
        this.animateLine()
        this.initDesc()
        this.initAnim()

        if (this.windowSizes.mobileDevice) {
            this.initFlashAnimMobile()
        } else {
            this.initFlashAnim()
        }

        this.initButtons()
        this.initLang()
    }

    setBackground() {
        switch (this.windowSizes.width < 780) {
            case true:
                this.setStyle(this.backgroundMobile);
                break;
            case false:
                this.setStyle(this.backgroundDesktop);
                break;
        }
    }

    initLang() {
        const container = document.querySelector('.header__right__langs')
        TweenLite.to(container, this.duration, {
            opacity: 1,
            ease: Quint.easeInOut
        })
    }

    initDesc() {
        const textContent = this
            .desc
            .textContent
            .split("")
        this.desc.innerHTML = ""
        this.descDivs = []
        textContent.map((l, index) => {
            const classItem = (l === " ")
                ? "sy-space"
                : "sy-" + index
            const item = "<span class='" + classItem + "'>" + l + "</span>"
            this.desc.innerHTML += item

            l !== " " && (this.descDivs.push(index))
        })
    }

    animateButton(el, delay) {
        TweenLite.fromTo(el, this.duration, {
            top: 30 + 'px',
            opacity: 0
        }, {
            top: 0,
            opacity: 1,
            delay: delay,
            ease: Quint.easeInOut,
            force3D: true
        })
    }

    initButtons() {
        const buttonAppleStore = document.querySelector('.section-hero__text__stores__item--apple')
        const buttonPlaytore = document.querySelector('.section-hero__text__stores__item--playstore')
        const buttonSteamStore = document.querySelector('.section-hero__text__stores__item--steam')
        const logo = document.querySelector('.section-hero__text__logo')

        this.animateButton(buttonAppleStore, 0)
        this.animateButton(buttonPlaytore, 0.2)
        this.animateButton(buttonSteamStore, 0.4)

        TweenLite.fromTo(logo, this.duration, {
            top: -30 + 'px',
            opacity: 0
        }, {
            top: 0,
            opacity: 1,
            ease: Quint.easeInOut,
            force3D: true
        })
    }

    getRandomInt(min, max) {
        return Math.random() * (max - min + 1) + min
    }

    initAnim() {
        this.desc.style.opacity = 1;
        this
            .descDivs
            .map((l, index) => {
                TweenLite.fromTo(this.desc.querySelector(".sy-" + l), this.duration, {
                    y: 10 + 2 * index
                }, {
                    y: 0,
                    opacity: 1,
                    delay: this.getRandomInt(.1, (this.descDivs.length - 3) * .00001),
                    force3D: true,
                    ease: Quint.easeInOut
                })
            })
    }

    initFlashAnim() {
        //const flashDiv = document.querySelector('.section-hero__background__neon')
        const backDiv = document.querySelector('.section-hero__background__back')
        /*
        TweenMax.to(flashDiv, 1.5, {
            opacity: 0.2,
            ease: RoughEase
                .ease
                .config({strength: 0.9, points: 20, randomize: true}),
            repeat: -1,
            yoyo: true
        });*/

        TweenMax.to(backDiv, this.duration, {
            opacity: 0,
            delay: .4,
            ease: RoughEase
                .ease
                .config({strength: 0.9, points: 20, randomize: true}),
            onComplete: function () {
                TweenMax.to(backDiv, 3, {
                    opacity: 0.3,
                    ease: RoughEase
                        .ease
                        .config({strength: 0.9, points: 20, randomize: true}),
                    repeat: -1,
                    yoyo: true
                });
            }
        });
    }

    initFlashAnimMobile() {
        const backDiv = document.querySelector('.section-hero__background__back')

        TweenMax.to(backDiv, this.duration, {
            delay: .3,
            opacity: 0,
            ease: Quint.easeInOut
        });
    }

    animateLine() {
        TweenLite.fromTo(this.line, this.duration, {
            width: 0
        }, {
            width: 100 + '%',
            ease: Quint.easeInOut,
            force3D: true
        })
    }

    setStyle(image) {
        this.container.style.backgroundImage = 'url(' + image + ')'
    }

    resize(windowSizes) {
        this.windowSizes = windowSizes
        this.setBackground()
    }
}

export default HeroBackground


// WEBPACK FOOTER //
// ./src/js/components/HeroBackground.js